<template>
  <div class="invoice_container" :style="`min-height:${mh}px`">
    <div class="inv_product boxshadow1">
      <div class="slogo-title">成品详情<span v-if="dataSet.goodsName">({{dataSet.goodsName}}-{{dataSet.goodsCode}})</span></div>
      <div class="product">
        <Form ref="form" :model="product" @submit.native.prevent>
          <Row :gutter="16" class="line1">
            <!-- <Col span="6" class="invoice_number">
              <FormItem prop="companyCode">
                <span class="title">公司代码</span>
                <Input v-model.trim="product.companyCode" disabled placeholder="请填写公司代码"></Input>
              </FormItem>
            </Col> -->
            <Col span="6" class="pn">
              <FormItem prop="goodsName">
                <span class="title ttooltip">
                  成品名称
                  <!-- <Tooltip content="可输入成品名称、成品料号进行辅助输入">
                    <svg-icon icon-class="help"></svg-icon>
                  </Tooltip> -->
                </span>
                <Input v-model.trim="product.goodsName" disabled placeholder="-"></Input>
              </FormItem>
            </Col>
            <Col span="6" class="exporter">
              <FormItem prop="invoiceCode">
                <span class="title">发票号</span>
                <Input v-model.trim="product.invoiceCode" disabled placeholder="-"></Input>
              </FormItem>
            </Col>
            <Col span="6" class="exporter">
              <FormItem prop="exporter">
                <span class="title">起运地</span>
                <Input v-model.trim="product.exporter" disabled placeholder="-"></Input>
              </FormItem>
            </Col>
            <Col span="6" class="exporter">
              <FormItem prop="importer">
                <span class="title">目的地</span>
                <Input v-model.trim="product.importer" disabled placeholder="-"></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" class="line2">
            <Col span="6" class="importer">
              <FormItem prop="goodsPN">
                <span class="title">成品料号</span>
                <Input v-model.trim="product.goodsPN" disabled placeholder="-"></Input>
              </FormItem>
            </Col>
            <Col span="6" class="name">
              <FormItem prop="goodsCode">
                <span class="title">成品商品编码</span>
                <Input v-model.trim="product.goodsCode" disabled placeholder="-"></Input>
              </FormItem>
            </Col>
            <Col span="6" class="key">
              <FormItem prop="goodsPrice">
                <span class="title">成品单价</span>
                <div class="tgroup_wrap">
                  <InputNumber v-model.trim="product.goodsPrice" disabled :min="0.01" placeholder="-"></InputNumber>
                  <Select v-model="product.unit" disabled transfer class="tgroup_item2" placeholder="-">
                    <Option v-for="item in ['CNY', 'USD']" :value="item" :key="item">{{ item }}</Option>
                  </Select>
                </div>
              </FormItem>
            </Col>
            <Col span="6" class="key">
              <FormItem prop="goodsWeight">
                <span class="title">成品重量</span>
                <div class="tgroup_wrap">
                  <InputNumber v-model.trim="product.goodsWeight" disabled :min="0.01" placeholder="-"></InputNumber>
                  <Select v-model="product.weightUnit" transfer disabled class="tgroup_item2" placeholder="-">
                    <Option v-for="item in weightUnitArr" :value="item" :key="item">{{ item }}</Option>
                  </Select>
                </div>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" class="line2">
            <Col span="12" class="key remark">
              <FormItem prop="goodsDescription">
                <span class="title">备注</span>
                <Input v-model.trim="product.goodsDescription" disabled clearable placeholder="-"></Input>
              </FormItem>
            </Col>
            <Col span="6" class="key">
              <FormItem prop="imported">
                <div class="title" style="visibility:hidden">包含进口成份</div>
                <Checkbox v-model="product.imported" disabled :true-value="'Y'" :false-value="'N'">包含进口成份</Checkbox>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="16" class="line2" v-if="isShowSpecialCraft">
            <!-- <Col span="6" class="key">
              <FormItem prop="goodsCount">
                <span class="title">成品数量</span>
                <Input v-model.trim="product.goodsCount" disabled placeholder="请填写成品数量"></Input>
              </FormItem>
            </Col> -->
            <!-- <Col span="6" class="key">
              <FormItem prop="goodsWeight">
                <span class="title">成品重量</span>
                <Input v-model.trim="product.goodsWeight" disabled placeholder="请填写成品重量"></Input>
              </FormItem>
            </Col> -->
            <!-- <Col span="6" class="key">
              <FormItem prop="unit">
                <span class="title">单位</span>
                <Input v-model.trim="product.unit" disabled placeholder="请填写价格单位"></Input>
              </FormItem>
            </Col> -->
            <!-- <Col span="6" class="key" style="height: 65px;">
              <span class="title">完全获取</span>
              <RadioGroup v-model="product.wo">
                <Radio label="Y" disabled><span>是</span></Radio>
                <Radio label="N" disabled><span>否</span></Radio>
              </RadioGroup>
            </Col> -->
            <!-- <Col span="6" class="key" style="height: 65px;" v-if="product.specialCraft">
              <Checkbox v-model="product.specialCraft" disabled :true-value="'Y'" :false-value="'N'">加工工序</Checkbox>
            </Col> -->
            <Col span="24" class="key specialgy">
              <FormItem prop="specialCraft">
                <div class="title">
                  <Checkbox v-model="product.specialCraft" disabled :true-value="'Y'" :false-value="'N'">加工工序</Checkbox>
                </div>
                <div class="scdesc">{{specialCraftDesc}}</div>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>

    <div class="inv_material boxshadow1">
      <div class="material_list">
        <div class="table-containter">
          <div class="table-wrap">
            <Table :columns="query.columns" :data="query.list" no-data-text="暂无记录"></Table>
          </div>
        </div>
      </div>
    </div>
    <CooModal :isShow="isShowModal" :dataSet="cooModalData" :isEdit="false" @changeState="isShowModal=$event"></CooModal>
  </div>
</template>

<script>
import CooModal from './cooModal'

export default {
  name: 'InvoiceMaterialShowContent',
  components: { CooModal },
  props: {
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    mh: {
      type: Number
    }
  },
  data () {
    return {
      isShowModal: false,
      isShowSpecialCraft: false,
      weightUnitArr: ['KG', 'K', 'T'],
      specialCraftDesc: '',
      cooModalData: {},
      product: {
        // companyCode: '',
        importer: '',
        exporter: '',
        invoiceCode: '',
        goodsPN: '',
        goodsName: '',
        goodsCode: '',
        goodsPrice: null,
        // goodsCount: '',
        goodsWeight: null,
        weightUnit: '',
        unit: '',
        goodsDescription: '',
        imported: 'N',
        // wo: 0,
        // specialCraft: 0
        // wo: 'N',
        specialCraft: 'N'
      },
      query: {
        columns: [
          // {type: 'selection', align: 'center', width: 50, className: 'tb_select'},
          {title: '原材料料号', key: 'materialPN', align: 'center', ellipsis: true, className: 'tb_company', render: (h, params) => {
            return h('span', { attrs: {title: params.row.materialPN} }, params.row.materialPN)
          }},
          {title: '原材料属性', key: 'materialType', align: 'center', ellipsis: true, render: (h, params) => {
            return h('span', {
              attrs: {title: this.$options.filters.getMaterialType(params.row.materialType)}
            }, this.$options.filters.getMaterialType(params.row.materialType))
          }},
          {
            title: '原材料名称',
            key: 'materialName',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', { attrs: {title: params.row.materialName} }, params.row.materialName)
            }
          },
          {
            title: '原材料商品编码',
            key: 'materialCode',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialCode}
              }, params.row.materialCode)
            }
          },
          {
            title: '原材料单价',
            key: 'materialPrice',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              let text = (this.$options.filters.amountThousands(params.row.materialPrice || 0) || '-') + params.row.materialUnit
              return h('span', {attrs: {title: text}}, text)
            }
          },
          // {
          //   title: '原材料单位',
          //   key: 'materialUnit',
          //   align: 'center',
          //   width: 100
          // },
          {
            title: '原材料重量',
            key: 'materialWeight',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {attrs: {title: params.row.materialWeight || '-'}}, params.row.materialWeight || '-')
            }
          },
          {title: '原材料原产地', key: 'materialOrigin', align: 'center',  ellipsis: true, render: (h, params) => {
            return h('span', { attrs: {title: params.row.materialOrigin} }, params.row.materialOrigin)
          }},
          {
            title: '原材料备注',
            key: 'materialDescription',
            align: 'center',
            ellipsis: true,
            render: (h, params) => {
              return h('span', {
                attrs: {title: params.row.materialDescription || '-'}
              }, params.row.materialDescription || '-')
            }
          },
          // {
          //   title: '操作',
          //   key: 'action',
          //   align: 'center',
          //   width: 120,
          //   render: (h, params) => {
          //     return h('div', {
          //       class: 'opr'
          //     }, [
          //       h('a', {
          //         style: {color: '#00B55F'},
          //         class: 'line2',
          //         on: {
          //           click: event => {
          //             event.stopPropagation()
          //             event.preventDefault()
          //             this.cooModalData = this._.find(this.query.list, item => item._id === params.row._id)
          //             this.isShowModal = true
          //           }
          //         }
          //       }, '查看')
          //     ])
          //   }
          // }
        ],
        list: []
      }
    }
  },
  watch: {
    dataSet (newVal, oldVal) {
      if (newVal && newVal.id) {
        // this.product = this._.assign({}, newVal)
        // this.product.wo = parseInt(this.product.wo) === 1 ? 1 : 0
        // this.product.specialCraft = parseInt(this.product.specialCraft) === 1 ? 1 : 0
        // this.product.wo = this.product.wo ? 'Y' : 'N'
        // this.product.specialCraft = this.product.specialCraft ? 'Y' : 'N'
        _.forEach(this.product, (value, key) => {
          if (key == 'goodsWeight') {
            let [weight, weightUnit] = this.splitWeightUnit(newVal[key] || '')
            this.product[key] = weight
            this.product['weightUnit'] = weightUnit
          } else if (['imported', 'specialCraft'].indexOf(key) != -1) {
            this.product[key] = newVal[key] == 1 || newVal[key] == 'Y' ? 'Y' : 'N'
          } else if (key != 'weightUnit') {
            this.product[key] = newVal[key]
          }
        })
        this.checkShowSpecialCraft()
        if (newVal.materials && newVal.materials.length > 0) {
          this.query.list = this._.map(newVal.materials, item => {
            item['_id'] = this._h.getRandomStr(32)
            return item
          })
        }
      }
    }
  },
  methods: {
    splitWeightUnit (val) {
      if (this._.trim(val)) {
        let reg = /[a-zA-Z]+?$/
        if (reg.test(val)) {
          let tmp = val.match(reg)[0], tmp2 = val.replace(tmp, '')
          tmp = tmp.toLocaleUpperCase()
          tmp = this.weightUnitArr.indexOf(tmp) != -1? tmp : ''
          return [parseFloat(tmp2) || null, tmp]
        }
      }
      return [null, '']
    },
    checkShowSpecialCraft () {
      if(this._.trim(this.product.importer) && this._.trim(this.product.exporter) && this._.trim(this.product.goodsCode)) {
        // this.$api.query.rule(27, 38, '0101210010', {
        // this.$api.query.rule2('中国', '印度尼西亚', '8472100000', {
        this.$api.query.rule2(this.product.importer, this.product.exporter, this.product.goodsCode, {
          success: response => {
            if (response.data.code === 200) {
              let ftas = response.data.data.ftas
              if (!this._.isEmpty(ftas)) {
                let criterions = _.reduce(ftas, function(res, item) {
                  res.push(...item.criterion)
                  return res
                }, [])
                let _criterion = this._.find(criterions, o => /加工工序/.test(o.name))
                if (_criterion) {
                  this.specialCraftDesc = _criterion.description || ''
                  this.product.specialCraft = this.product.specialCraft || 'N'
                  this.isShowSpecialCraft = true
                } else {
                  this.product.specialCraft = ''
                  this.isShowSpecialCraft = false
                }
              }
            } else {
              this.product.specialCraft = ''
              this.isShowSpecialCraft = false
            }
          },
          error: error => {
            this.product.specialCraft = ''
            this.isShowSpecialCraft = false
          }
        })
      } else {
        this.product.specialCraft = ''
        this.isShowSpecialCraft = false
      }
    }
  }
}
</script>
<style scoped>
  .invoice_container{
    background-color: #fff;
    /* padding: 18px 16px 25px; */
  }
  .inv_product{
    padding: 18px 18px 24px;
  }
  .inv_material{
    margin-top: 30px;
    padding: 18px;
  }
  .invoice_container{
    background-color: #fff;
    padding: 18px 16px 25px;
  }
  .slogo-title{
    color: #323232;
    font-weight: bold;
    font-size: 16px;
    padding: 0 18px 0 0;
    margin-bottom: 6px;
  }
  .product{
    font-size: 14px;
  }
.product >>> .ivu-checkbox-wrapper{
    font-size: 16px;
  }
  .product >>> .ivu-checkbox-wrapper .ivu-checkbox{
    margin-right: 5px;
  }
  .product >>> .ivu-select-dropdown.ivu-auto-complete{
    height: 200px;
  }
.product >>> .ivu-select-dropdown.ivu-auto-complete::-webkit-scrollbar-track-piece {
  background: transparent;
}
.product >>> .ivu-select-dropdown.ivu-auto-complete::-webkit-scrollbar {
  width: 6px;
}
.product >>> .ivu-select-dropdown.ivu-auto-complete::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
}
  .product >>> .ivu-form-item{
    margin-bottom: 0;
    width: 90%;
  }
  .product >>> .ivu-col.remark .ivu-form-item{
    width: 95.3%;
  }
  .product >>> .ivu-col.specialgy .ivu-form-item{
    width: 98.5%;
  }
  .product >>> .scdesc{
    background-color: #e6f1fd;
    border-radius: 6px;
    display: inline-block;
    padding: 5px 10px;
    line-height: 26px;
    font-size: 14px;
  }
  .product >>> .ivu-form-item-error-tip{
    right: 0;
    left: inherit;
    top: 10px;
    padding-top: 0;
    font-size: 13px;
  }
  .product >>> .ivu-row{
    margin-bottom: 12px;
  }
  .product >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .product >>> .ivu-row .ivu-col{
    display: flex;
    align-items: center;
    height: 100%;
  }
  .product >>> .ivu-row .ivu-col .title{
    white-space: nowrap;
    font-size: 16px;
  }
  .product >>> .ivu-row .ivu-col .ivu-input,
  .product >>> .ivu-row .ivu-col .ivu-input-number,
  .product >>> .ivu-row .ivu-col .ivu-select-selection{
    border-color: #f3efef;
    border-radius: 2px;
    font-size: 16px;
  }
  .product >>> .ivu-select-selected-value,
  .product >>> .ivu-select-item{
    font-size: 16px !important;
  }
  .product >>> .ivu-row .ivu-col .ivu-form-item-error .ivu-input{
    border-color: #ed3f14;
  }
  .product >>> .ivu-row .ivu-col .ivu-input:focus{
    border-color: #57a3f3;
  }
  .actions{
    position: relative;
    text-align: right;
  }
  .actions .add{
    border: 1px solid #bc8cf0;
    background-color: #bc8cf0;
    color: #fff;
    margin: 0 20px;
  }
  .actions >>> .ivu-btn{
    border-radius: 2px;
    width: 130px;
    font-size: 16px;
  }
  .actions >>> .ivu-btn .ivu-icon-ios-search{
    background: url("~@/assets/images/home/add.png") 0 center no-repeat transparent;
    background-size: 14px;
    width: 14px;
    height: 14px;
    position: relative;
    top: 2px;
  }
  .actions >>> .upload.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/import.png");
  }
  .actions >>> .del.ivu-btn .ivu-icon-ios-search{
    background-image: url("~@/assets/images/home/del.png");
  }
  .actions >>> .ivu-btn>.ivu-icon+span, .ivu-btn>span+.ivu-icon{
    margin-left: 2px;
  }
  .actions >>> .ivu-btn .ivu-icon-ios-search:before{
    content: "";
  }
  .actions .upload{
    border: 1px solid #00B55F;
    color: #00B55F;
  }
  .actions .del{
    border: 1px solid #8ac3fa;
    background-color: #8ac3fa;
    color: #fff;
  }
  .material_list{
    /* margin-top: 20px; */
    position: relative;
  }
.table-containter{
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    padding-bottom: 3px;
  }
  .table-wrap{
    width: 100%;
    border: 1px solid #eaf7ff;
  }
/* .table-containter::-webkit-scrollbar-track-piece {
  background: transparent;
}
.table-containter::-webkit-scrollbar {
  height: 6px;
}
.table-containter::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border-radius: 20px;
} */
.table-wrap >>> .ivu-table-wrapper{
  
}
.table-wrap >>> .ivu-table-body tr:nth-child(even) td{
  background-color: #eaf7ff;
}
.table-wrap >>> .ivu-table:before, .table-wrap >>> .ivu-table:after{
  background-color: #eaf7ff;
}
  .material_list >>> .ivu-table-wrapper{
    border: 0 none;
    /* box-shadow: 0 2px 4px 0 rgba(196,196,196,0.50); */
  }
  .material_list >>> .ivu-table{
    color: #686765;
  }
  .material_list >>> .ivu-table th{
    background-color: #eaf7ff;
    font-size: 14px;
    font-weight: normal;
    border-color: #eaf7ff;
  }
  .material_list >>> .ivu-table th .ivu-table-cell{
    white-space: nowrap;
    font-size: 16px;
    color: #333;
  }
  .material_list >>> .ivu-table td{
    font-size: 16px;
    border-width: 0;
  }
  .material_list >>> .ivu-table .ivu-checkbox-wrapper{
    margin-right: 0;
  }
  .material_list >>> .ivu-table .tb_select .ivu-table-cell{
    padding-right: 0;
  }
  .material_list >>> .ivu-table .tb_company .ivu-table-cell{
    padding-left: 0;
  }
  .material_list >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .files >>> .ivu-table .opr a.line2:after{
    /*text-decoration: underline;*/
    bottom: 0;
  }
  .files{
    margin: 10px 0 25px;
  }
  .btn{
    width: 130px;
    border: 1px solid #0774b5;
    border-radius: 3px;
    height: 32px;
    font-size: 16px;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    background-color: #0774b5;
    color: #fff;
    margin: 30px auto 0;
    display: block;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
.tgroup_wrap{
  position: relative;
  padding-right: 73px;
}
.tgroup_wrap .tgroup_item2{
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width:70px;
  margin-top: 0.5px;
}
.tgroup_wrap .ivu-input-number{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RulesDecide/zh-CN/Detail.vue